import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import * as echarts from 'echarts';

const styles = {
  graphDimensions: {
    width: '80vw',
    height: '60vh',
    marginTop: '30px',
  },
};

class BasicBarGraph extends Component {
  constructor(props) {
    super(props);

    this.chart = null;
    this.chartRef = React.createRef();
  }

  componentDidUpdate(prevProps) {
    if (this.chartRef.current !== null) {
      this.chart = echarts.init(this.chartRef.current);

      if (prevProps.xAxis !== this.props.xAxis || prevProps.yAxis !== this.props.yAxis) {
        this.chart.setOption({
          colorBy: 'xAxis',
          color: this.props.colors || [
            '#5470c6',
            '#91cc75',
            '#fac858',
            '#ee6666',
            '#73c0de',
            '#3ba272',
            '#fc8452',
            '#9a60b4',
            '#ea7ccc',
          ],
          tooltip: {},
          xAxis: {
            type: 'category',
            data: this.props.xAxis || [],
          },
          yAxis: {
            type: 'value',
          },
          series: [
            {
              data: this.props.yAxis || [],
              type: 'bar',
            },
          ],
        });
      }

      if (this.props.handleSeriesClick) {
        this.chart.on('click', 'series', this.props.handleSeriesClick);
      }
    }
  }

  render() {
    return (
      <React.Fragment>
        <div id="logins-chart" style={{ width: '85vw', height: '65vh', marginTop: '30px' }} ref={this.chartRef} />
      </React.Fragment>
    );
  }
}

export default withStyles(styles)(BasicBarGraph);



// WEBPACK FOOTER //
// ./src/components/graphs/BasicBarGraph.jsx